import { useEffect, useState } from "react";

/** True while the CSS media query matches (false where matchMedia is missing). */
export function useMediaQuery(query: string): boolean {
  const get = () => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(query).matches;
  const [matches, setMatches] = useState(get);
  useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(query);
    const on = () => setMatches(mql.matches);
    on();
    mql.addEventListener("change", on);
    return () => mql.removeEventListener("change", on);
  }, [query]);
  return matches;
}

/** Phones and small windows: the HUD folds into dropdowns. */
export const COMPACT_QUERY = "(max-width: 700px), (max-height: 520px)";

/**
 * Browsers driven by test automation (navigator.webdriver) get still 3D
 * pictures: software-rendered animation would starve the test of time.
 */
export const AUTOMATED = typeof navigator !== "undefined" && navigator.webdriver === true;
